import useConfig from "../useConfig"
import useCan from "./useCan"

export const CheckPermission =(role:string | Array<string>, id?:string)=>{
    const {companyId,locationId} = useConfig()
    const can = useCan()
    return id? can([...(typeof role === 'string' ? [role]:[...role])], id!) :  can([...(typeof role === 'string' ? [role]:[...role])], companyId!) || can([...(typeof role === 'string' ? [role]:[...role])], locationId)
}
